import ManagerRepository from 'coreClasses/ManagerRepository';
import {IEventData} from 'coreClasses/events/IEvents';
import EventModel from '../EventModel';

/**
 * Represents RecommendationsReadyEventModel
 */
export default class RecommendationsReadyEventModel extends EventModel {
	public type: string;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		this.type = data.type;
	}
};
